import { memo } from 'react';
import ShareNotification from '@/common/ShareNotification';
import { useIsGiveawayModalOpen } from '~/context/giveaway/ModalContext';
import GiveawayModal from './GiveawayModal';

type OwnProps = {
  loadGiveawayModal: boolean;
};

const ModalsContent = memo(({ loadGiveawayModal }: OwnProps) => (
  <>
    {loadGiveawayModal && <GiveawayModal />}
    <ShareNotification />
  </>
));

const Modals = () => {
  const isGiveawayModalOpen = useIsGiveawayModalOpen();

  return <ModalsContent loadGiveawayModal={isGiveawayModalOpen} />;
};

export default Modals;
